import { IComponent, getV2ValueWP } from "@eventr/common";
import { ColoursObj } from "@eventr/common-storybook";
import { Stack } from "@mui/material";
import { useBoundStore } from "../../state/bound.store";
import { useGlobalRouter } from "../../feat/globalRouter/useGlobalRouter";
import { ComponentFinder } from "../componentFinder";

interface ISimpleCardProps {
  data?: any;
  renderOptions?: ISimpleCardOptions;
  parentData?: any;
  past?: boolean;
}
interface ISimpleCardOptions {
  body?: IComponent[];
  border?: boolean;
  padding?: string;
}

export const SimpleCard = ({ data, renderOptions, parentData, past }: ISimpleCardProps) => {
  const experimental = useBoundStore((s) => s.experimental);
  const { pushPath } = useGlobalRouter();

  const handleClick = () => {
    if (experimental) {
      const itemID = getV2ValueWP("_id", data);

      pushPath("home/" + itemID);
    }
  };

  return (
    <Stack
      onClick={handleClick}
      sx={{
        overflow: "hidden",

        bgcolor: past
          ? ColoursObj.shades.shade4
          : experimental
            ? data.live
              ? ColoursObj.backgrounds.secondary
              : ColoursObj.backgrounds.card
            : ColoursObj.backgrounds.secondary,

        borderRadius: "8px",

        border: renderOptions?.border || (data?.colours?.backgoundColour && !data?.colours?.pdfOnly)
          ? `1px solid ${data?.colours?.backgoundColour ? data?.colours?.backgoundColour : ColoursObj.core.primary}`
          : "0px",

        boxShadow: experimental || ColoursObj.backgrounds.primary === ColoursObj.backgrounds.secondary
          ? "0px 2px 3px rgba(0, 0, 0, 0.1)"
          : undefined
      }}>
      {renderOptions?.body && (
        <Stack sx={{
          padding: renderOptions?.padding ?? "8px 8px"
        }}>
          {renderOptions?.body?.map((c, i) => {
            return (
              <ComponentFinder
                key={"finder_" + i}
                componentKey={c.componentKey}
                data={data}
                renderOptions={c}
                parentData={parentData}
                isInPast={past}
              />
            );
          })}
        </Stack>
      )}
    </Stack>
  );
};
